var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/ui-components/src/lib/modules/timer/timer.element.ts
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

// libs/ui-components/src/lib/modules/timer/timer.style.ts
import { css } from "lit";
var timerStyle = css`
  
`;

// libs/ui-components/src/lib/modules/timer/timer.element.ts
var millisecondsInDay = 864e5;
var millisecondsInHour = 36e5;
var millisecondsInMinute = 6e4;
var millisecondsInSecond = 1e3;
var TimerElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.expirationTime = Date.now();
  }
  connectedCallback() {
    super.connectedCallback();
    this.viewUpdater();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.timer && clearTimeout(this.timer);
  }
  render() {
    return html`
      <span>${this.calculateTimeView()}</span>
    `;
  }
  viewUpdater() {
    this.requestUpdate();
    this.timer = setTimeout(() => this.viewUpdater(), 500);
  }
  calculateTimeView() {
    const currentTime = Date.now();
    const differenceInMilliseconds = this.expirationTime - currentTime;
    if (differenceInMilliseconds <= 0) {
      return `00:00`;
    }
    if (differenceInMilliseconds < millisecondsInDay) {
      const hours = Math.floor(differenceInMilliseconds / millisecondsInHour);
      const minutes = Math.floor(differenceInMilliseconds % millisecondsInHour / millisecondsInMinute);
      const seconds = Math.floor(differenceInMilliseconds % millisecondsInMinute / millisecondsInSecond);
      if (hours === 0) {
        return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      } else {
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      }
    } else {
      const days = Math.floor(differenceInMilliseconds / millisecondsInDay);
      const hours = Math.floor(differenceInMilliseconds % millisecondsInDay / millisecondsInHour);
      return `${days}D ${hours}h`;
    }
  }
};
TimerElement.tagName = "inch-timer";
TimerElement.styles = timerStyle;
__decorateClass([
  property({ type: Number })
], TimerElement.prototype, "expirationTime", 2);
TimerElement = __decorateClass([
  customElement(TimerElement.tagName)
], TimerElement);
export {
  TimerElement
};
//# sourceMappingURL=index.esm.js.map
